<div *ngIf="showPulsation$ | async" @fade class="pulsing-halo"></div>
<div class="dot"></div>
